import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { BalanceHistory } from '~/shared/api'
import {
  transactionBalanceTypeEnumLabels,
  transactionMoveFundsTypeEnumLabels,
} from '~/shared/config/constants'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { filters } from './filters'
import { GridRow } from './types'

export const ListBalanceHistories = () => {
  const { t } = useTranslation()
  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, filters = [], sort) => {
      let builder = BalanceHistory.limit(pageSize)

      sort
        ? (builder = builder.orderBy(sort))
        : (builder = builder.orderBy('-appliedAt'))

      filters.forEach(({ key, value }) => {
        builder = builder.where(key, value)
      })

      const response = await builder.get(page)
      const data = response.getData()
      const rows = data.map((balanceHistories) => {
        const moveFundsType = balanceHistories?.getMoveFundsType()
        const balanceType = balanceHistories?.getBalanceType()
        return {
          ...balanceHistories.getAttributes(),
          id: balanceHistories.getApiId() as string,
          moveFundsType,
          moveFundsTypeLabel:
            moveFundsType &&
            t(transactionMoveFundsTypeEnumLabels[moveFundsType]),
          balanceType:
            balanceType && t(transactionBalanceTypeEnumLabels[balanceType]),
          paymentType: balanceHistories?.getPaymentType(),
        }
      })

      return {
        rows,
      }
    },
    [t],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='balance-histories-list'
      smallTitle={t('balances')}
      fetchRows={fetchRows}
      columns={columns}
      filters={filters}
      isSimplePagination
      canCash={false}
    />
  )
}
